var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoPagerduty = function SvgLogoPagerduty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "PagerDuty")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06AC38",
    d: "M18.217 31.387H14v7.512h4.217v-7.512ZM29.882 12.071c-2.263-1.18-3.833-1.377-7.54-1.377H14v17.098h8.306c3.305 0 5.77-.197 7.942-1.61 2.373-1.538 3.596-4.095 3.596-7.046 0-3.202-1.515-5.759-3.962-7.065Zm-6.608 12.144h-5.057V14.36l4.765-.035c4.345-.054 6.517 1.448 6.517 4.846 0 3.65-2.683 5.044-6.225 5.044Z"
  })));
};
export default SvgLogoPagerduty;